<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
            <base-dropdown v-if="activeModules.length > 0">
                <base-button v-if="currentProfile == 'pwd_sales_reports'" slot="title" type="success" class="dropdown-toggle">
                    BIR Reports - PWD Sales Reports
                </base-button>
                <base-button v-else-if="currentProfile == 'pos_collections_reports'" slot="title" type="success" class="dropdown-toggle">
                    BIR Reports - POS Collection Reports
                </base-button>
                <base-button v-else-if="currentProfile == 'pos_cashier_accountability_reports'" slot="title" type="success" class="dropdown-toggle">
                    BIR Reports - POS Cashier Accountablity Reports
                </base-button>
                <base-button v-else-if="currentProfile == 'pos_vat_exempt_sales'" slot="title" type="success" class="dropdown-toggle">
                    BIR Reports - POS VAT Exempt Sales
                </base-button>
                <base-button v-else-if="currentProfile == 'pos_vat_sales_summaries'" slot="title" type="success" class="dropdown-toggle">
                    BIR Reports - POS VAT Sales Summary
                </base-button>
                <base-button v-else-if="currentProfile == 'bir_sales_reports'" slot="title" type="success" class="dropdown-toggle">
                    BIR Reports - BIR Sales Reports
                </base-button>
                <base-button v-else-if="currentProfile == 'bir_consolidated_reports'" slot="title" type="success" class="dropdown-toggle">
                    BIR Reports - BIR Consolidated Reports
                </base-button>
                <base-button v-else slot="title" type="success" class="dropdown-toggle">
                    BIR Reports - {{_.startCase(currentProfile)}}
                </base-button>
                <a v-for="profile in activeModules" :key="profile.id"
                    @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)"
                    class="dropdown-item" href="#">{{profile.name}}</a>
            </base-dropdown>
            <base-dropdown v-else>
                <base-button slot="title" type="primary" class="dropdown-toggle">
                    BIR Reports
                </base-button>
                <a class="dropdown-item" disabled>No active module/s under this feature</a>
            </base-dropdown>
        </base-header>
        <!-- <img style="display: none;" id='reportLogo' :src="imagepath" alt='Report Logo' crossorigin="anonymous"/> -->
        <div id="logoDiv" style="display: none;"></div>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <sc-pwd-sales-report v-if="currentProfile == 'senior_citizen_sales_reports' || currentProfile == 'pwd_sales_reports'"></sc-pwd-sales-report>
                    <bir-sales-report v-if="currentProfile == 'bir_sales_reports'"></bir-sales-report>
                    <bir-consolidated-report v-if="currentProfile == 'bir_consolidated_reports'"></bir-consolidated-report>
                    <pos-cashier-accountability-report v-if="currentProfile == 'pos_cashier_accountability_reports'"></pos-cashier-accountability-report>
                    <terminal-sales-report v-if="currentProfile == 'terminal_sales_reports'"></terminal-sales-report>
                    <hourly-sales-report v-if="currentProfile == 'hourly_sales_reports'"></hourly-sales-report>
                    <pos-collections-report v-if="currentProfile == 'pos_collections_reports'"></pos-collections-report>
                    <pos-vat-exempt-sales v-if="currentProfile == 'pos_vat_exempt_sales'"></pos-vat-exempt-sales>
                    <pos-vat-sales-summary v-if="currentProfile == 'pos_vat_sales_summaries'"></pos-vat-sales-summary>
                    <pos-tender-report v-if="currentProfile == 'pos_tender_reports'"></pos-tender-report>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    // import ScPwdSalesReport from '../Bir Reports/ScPwdSalesReport';
    import ScPwdSalesReport from '../Bir Reports/ScPwdSalesBook';
    import BirSalesReport from '../Bir Reports/BirSalesReportV2';
    import BirConsolidatedReport from '../Bir Reports/BirConsolidatedReport';
    import TerminalSalesReport from '../Bir Reports/TerminalSalesReport';
    import PosCashierAccountabilityReport from '../Bir Reports/PosCashierAccountabilityReport';
    import HourlySalesReport from '../Bir Reports/HourlySalesReport';
    import PosCollectionsReport from '../Bir Reports/PosCollectionsReport';
    import PosVatExemptSales from '../Bir Reports/PosVatExemptSales';
    import PosVatSalesSummary from '../Bir Reports/PosVatSalesSummary';
    import PosTenderReport from '../Bir Reports/PosTenderReport';

    import {
        mapState,
        mapActions
    } from 'vuex'

    export default {
        data() {
            return {
                activeModules: [],
                accessRights: [],
                imagepath: secureStorage.getItem("account_logo")
            }
        },
        mounted: async function () {
            var component_x = this;

            //Fix: S3 image CORS error in jsPDF
            const corsImageModified = new Image();
            corsImageModified.crossOrigin = "Anonymous";
            corsImageModified.id = "reportLogo";
            corsImageModified.src = secureStorage.getItem("account_logo") + "?not-from-cache-please";
            document.getElementById("logoDiv").appendChild(corsImageModified);
            //Fix: S3 image CORS error in jsPDF

            var categoryId = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories?name=BIR Reports', null, null)
            component_x.activeModules = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories/' + categoryId[0].id + '/enabled_modules', null, null)
            if (component_x.activeModules.length > 0) {
                var profile = _.snakeCase(component_x.activeModules[0].name)
                component_x.setCurrentProfile(_.pluralize(profile), component_x.activeModules[0].id);
            } else {
                component_x.setCurrentProfile(null, null);
            }
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components: {
            ScPwdSalesReport,
            BirSalesReport,
            TerminalSalesReport,
            PosCollectionsReport,
            BirConsolidatedReport,
            PosCashierAccountabilityReport,
            HourlySalesReport,
            PosVatExemptSales,
            PosVatSalesSummary,
            PosTenderReport
        },
        methods: {
            ...mapActions(['updateCurrentProfile', 'updateParameters']),
            async setCurrentProfile(profile, id) {
                var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
                if (_.isEmpty(accessRightsRequest.access_rights) == false){
                    this.accessRights = accessRightsRequest.access_rights[id]
                }else {
                    this.accessRights = []
                }
                this.updateCurrentProfile(profile);
            }
        }
    };
</script>

<style></style>